import profilePhotoUrl from '~/helpers/profilePhotoUrl'

export default {
  methods: {
    companyLogo (company) {
      return profilePhotoUrl(company, 'logo')
    },
  },
}
